import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des activités d'une agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyActivityList = (token, agencyId) => {
    const url = `/api-v1/admin/agency/${agencyId}/activity/list`;
    return getRequest(url, token)
}

/**
 * Récupération de la liste des activités.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getActivityList = (token) => {
    const url = `/api-v1/admin/activity/list`;
    return getRequest(url, token)
}

/**
 * Récupération d'une activité.
 *
 * @param string $token Jeton d'authentification.
 * @param int $activityId Identifiant de l'activité.
 */
export const getActivityInfos = (token, activityId) => {
    const url = `/api-v1/admin/activity/${activityId}/infos`;
    return getRequest(url, token)
}

/**
 * Modification du statut d'une activité.
 *
 * @param string $token Jeton d'authentification.
 * @param int $activityId Identifiant de l'activité.
 */
export const setActivityEnabled = (token, body) => {
    const url = `/api-v1/admin/activity/enable`;
    return postRequest(url, body, token)
}

/**
 * Modification d'une activité.
 *
 * @param string $token Jeton d'authentification.
 * @param int $activityId Identifiant de l'activité.
 */
export const updateActivityInfos = (token, body) => {
    const url = `/api-v1/admin/activity/update`;
    return postRequest(url, body, token)
}

/**
 * Suppression d'une activité.
 *
 * @param string $token Jeton d'authentification.
 * @param int $activityId Identifiant de l'activité.
 */
export const deleteActivityFromDB = (token, body) => {
    const url = `/api-v1/admin/activity/delete`;
    return postRequest(url, body, token);
}